import { defineStore } from "pinia";
import { getApiAxios } from "~/helpers";
import api from "~/config/extensionsApi";

export const useBlogsStore = defineStore("blogs", {
  state: () => ({
    blogs: [],
  }),

  getters: {
    getBlogs(state) {
      return state.blogs;
    },
  },
  actions: {
    async loadBlogs() {
      try {
        const response = await getApiAxios(api.blog.blog_post);
        const results = Array.isArray(response.result)
          ? response.result.map(function (blog) {
              let data = blog?.yoast_head_json;
              data.id = blog?.id;
              data.name = blog?.title?.rendered;
              data.url_key = blog?.link;
              data.category_ids = blog?.categories;
              data.publish_date = blog?.yoast_head_json?.article_published_time;
              data.image = blog?.yoast_head_json?.og_image[0]?.url;
              data.description = blog?.yoast_head_json?.og_description;
              data.titleLink =
                blog?.yoast_head_json?.schema?.["@graph"]?.find((item) => {
                  return item["@type"] === "Article";
                })?.articleSection?.[0] || "";
              return data;
            })
          : [];

        this.blogs = results;
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    },
  },
});
